import IPagination from 'interfaces/IPagination';

import { ReduxStore } from 'store/types';

function getAllPagination(state: ReduxStore): IPagination {
  return state.product.getAll.config.pagination;
}

export default getAllPagination;
